<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CheckoutPaymentStripeScriptLoader",
  props: {
    stripeKey: {
      type: String,
      required: true,
    },
    currentLocale: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const stripe = new Promise(resolve => {
      const script = document.createElement("script");
      script.setAttribute("src", "https://js.stripe.com/v3");
      script.onload = () => resolve();
      document.head.appendChild(script);
    });
    stripe.then(() => {
      this.setGlobalStripe(window.Stripe(this.stripeKey, { locale: this.currentLocale }));
    });
  },
  methods: {
    ...mapActions({ setGlobalStripe: "checkoutPayment/setGlobalStripe" }),
  },
};
</script>
